import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select level of importance", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "high" }, "High", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "medium" }, "Medium", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "low" }, "Low", -1)
const _hoisted_8 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "text-error"
}
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  key: 0,
  class: "text-error"
}
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { type: "submit" }

import { ref } from 'vue';

import { validateForm } from '@/utils';
import { useTodo, useModal } from '@/composables';
import { AddTask, CategoryTask } from '@/models/task';


export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  setup(__props) {

const { getTaskActive, addTask, updateDataTask } = useTodo();
const { categoryInModal, textsModal, setCloseModal } = useModal();
const isFormErrorSelect = ref(false);
const isFormErrorInput = ref(false);

const taskActive = getTaskActive();
const dataForm = ref<AddTask>({
  title: taskActive.value?.title || '',
  description: taskActive.value?.description || '',
  relevance: taskActive.value?.relevance || '',
  category: categoryInModal.value,
});

const resetForm = () => {
  dataForm.value = {
    title: '',
    description: '',
    relevance: 'low',
    category: CategoryTask.Todo,
  };
};

const onAddTask = (dataForm: AddTask) => {
  const { inputHasError, selectHasError, isFormValid } = validateForm(dataForm);

  isFormErrorInput.value = inputHasError.value;
  isFormErrorSelect.value = selectHasError.value;

  setTimeout(() => {
    isFormErrorInput.value = false;
    isFormErrorSelect.value = false;
  }, 2000);

  if (isFormValid) {
    addTask(dataForm);
    setCloseModal();
    resetForm();
  }
};

const onUpdateTask = (dataForm: AddTask) => {
  updateDataTask(taskActive.value, dataForm);
  setCloseModal();
  resetForm();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_unref(setCloseModal) && _unref(setCloseModal)(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(_unref(textsModal).title), 1),
        _createElementVNode("i", {
          class: "fa-solid fa-xmark",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
            resetForm();
            _unref(setCloseModal)();
          })
        })
      ]),
      _createElementVNode("form", {
        class: "modal-form",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (!_unref(taskActive) ? onAddTask(dataForm.value) : onUpdateTask(dataForm.value)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.relevance) = $event)),
            class: _normalizeClass(isFormErrorSelect.value && 'form-error')
          }, _hoisted_8, 2), [
            [_vModelSelect, dataForm.value.relevance]
          ]),
          (isFormErrorSelect.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, "This field is required"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.title) = $event)),
            type: "text",
            placeholder: "Enter new task",
            class: _normalizeClass(isFormErrorInput.value && 'form-error')
          }, null, 2), [
            [_vModelText, dataForm.value.title]
          ]),
          (isFormErrorInput.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, "This filed is required"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.value.description) = $event)),
            placeholder: "Enter description"
          }, null, 512), [
            [_vModelText, dataForm.value.description]
          ])
        ]),
        _createElementVNode("button", _hoisted_13, _toDisplayString(_unref(textsModal).textButton), 1)
      ], 32)
    ])
  ]))
}
}

})